export default __webpack_public_path__ + "static/Deck,-Shed,-Fence-Removal-f8fabea00c49137714a0eff538ca3ed8.jpg";